(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('UnitService', UnitService)

    /** @ngInject */
    function UnitService(HttpService) {
        const UnitService = {
            get: get,
            getAll: getAll
        }

        return UnitService;

        function get(unitId) {
            return HttpService.get(`/units/${unitId}`);
        }

        function getAll() {
            return HttpService.get('/units/resumed');
        }
    }
}());